import React from "react";
import { Form } from "react-bootstrap";
import { STATES } from "helper/const";
import ActiveInactiveRadio from "../shared/ActiveInactiveRadio";

const StateSelectionSection = ({
  taxState,
  onStateChange,
  activeValue,
  onActiveChange,
  isLoading,
  styles,
}) => {
  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>State & County Tax Management</h2>
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.label}>
            State <span className={styles.required}>*</span>
          </label>
          <Form.Control
            as="select"
            value={taxState}
            onChange={onStateChange}
            className={styles.select}
          >
            <option value="">Choose...</option>
            {STATES.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </Form.Control>
        </div>

        <ActiveInactiveRadio
          value={activeValue}
          onChange={onActiveChange}
          isLoading={isLoading}
          disabled={!taxState}
        />
      </div>
    </div>
  );
};

export default StateSelectionSection;
